module.exports = __webpack_public_path__ + "media/Video 93s.dee7b796.mp4";